import React from "react";
import { Helmet } from 'react-helmet';

const metadata = props => {

  return (
    <div>
      <Helmet>
        <title>{props.title}</title>
        <meta name="description" content={props.description} />
        <meta name="keywords" content={props.keywords} />
      </Helmet>
    </div>
  );

}

export default metadata;



// WEBPACK FOOTER //
// ./src/components/Metadata/Metadata.js